import { Check } from 'lucide-react';
import { COLOR_PALETTE } from '@/features/crm/types';

interface ColorPickerProps {
  value: string;
  onChange: (colorClass: string) => void;
}

/** Exibe amostras da paleta de cores como mini-badges clicáveis */
export function ColorPicker({ value, onChange }: ColorPickerProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {COLOR_PALETTE.map((colorClass) => (
        <button
          key={colorClass}
          type="button"
          onClick={() => onChange(colorClass)}
          className={`relative inline-flex items-center justify-center rounded-full border px-3 py-1 text-[11px] font-bold cursor-pointer transition-all ${colorClass} ${
            value === colorClass
              ? 'ring-2 ring-white/40 ring-offset-1 ring-offset-transparent scale-105'
              : 'opacity-60 hover:opacity-100 hover:scale-105'
          }`}
          title={colorClass}
        >
          {value === colorClass && (
            <Check className="h-3 w-3 absolute -top-1 -right-1 bg-accent rounded-full p-0.5 text-midnight" />
          )}
          Aa
        </button>
      ))}
    </div>
  );
}
